import { render, staticRenderFns } from "./OtherDocumentCard.vue?vue&type=template&id=7632e9d8&scoped=true"
import script from "./OtherDocumentCard.vue?vue&type=script&lang=js"
export * from "./OtherDocumentCard.vue?vue&type=script&lang=js"
import style0 from "./OtherDocumentCard.vue?vue&type=style&index=0&id=7632e9d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7632e9d8",
  null
  
)

export default component.exports